/**
 * Load locale from .json file
 *
 * @param {string} locale
 * @param {string} baseUrl
 * @return {Promise<unknown>}
 */
export const loadLocale = (locale, baseUrl) => (
  new Promise((resolve, reject) => {
    const httpRequest = new XMLHttpRequest()
    httpRequest.overrideMimeType('application/json')
    httpRequest.open('GET', `${baseUrl}/json/${locale}.json`, true)
    httpRequest.onreadystatechange = () => {
      if (
        httpRequest.readyState === 4
        && (httpRequest.status === 200 || httpRequest.status === 304)
      ) {
        resolve(JSON.parse(httpRequest.responseText || '') || {})
      }
    }
    httpRequest.onerror = () => reject(null)
    httpRequest.send()
  })
)

/**
 * Check if cookies allowed
 *
 * @return {boolean}
 */
export const isCookiesAllowed = () => {
  const oipCookie = getCookie('OIP')

  return oipCookie
    .split(',')
    .some(function (key) {
      return key === 'gdpr|1'
    })
}

/**
 * Calls the "/opt-in-select/cookie/create/" endpoint using an XMLHttpRequest
 * to save the cookie
 *
 * @param {string} name
 * @param {value} value
 * @returns {XMLHttpRequest} xhr
 */
export const setCookie = (name, value) => {
  const endPoint = `/opt-in-select/cookie/create/${name}?value=${value}&js=true`
  const xhr = new XMLHttpRequest()
  xhr.open('GET', endPoint, true)
  xhr.send()

  return xhr
}

/**
 * Get cookie value by name
 *
 * @param {string} name Cookie name
 * @return {string}
 */
export const getCookie = (name) => {
  const values = document.cookie.split(';')

  for (let i = 0; i < values.length; i++) {
    const value = values[i].trim()
    if (value.indexOf(`${name}=`) === 0) {
      return value.replace(/^.+?=/, '')
    }
  }

  return ''
}

/**
 * Get the url of current file
 *
 * @param {string} name Name of the file
 * @return {{ full: string, base: string, query: string }}
 */
export const getScriptUrl = (name) => {
  let src = ''
  const fileName = `/${name}.js`
  const scripts = document.getElementsByTagName('script')
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.indexOf(fileName) !== -1) {
      src = scripts[i].src
      break
    }
  }

  return {
    full: src,
    baseUrl: src.replace(RegExp(`${fileName}(.*)`), ''),
    query: src.split('?')[1] || '',
  }
}

/**
 * Parse string of query parameters into an object
 *
 * @param {string} query
 * @return {{[string]: string}}
 */
export const parseQueryParameters = (query) => {
  if (query === '') {
    return {}
  }

  const paramsWhole = query.split('&')
  const params = {}

  for (let i = 0; i < paramsWhole.length; i++) {
    const parts = paramsWhole[i].split('=')
    params[parts[0]] = parts[1] || ''
  }

  return params
}

/**
 * Set property to window object, indicating that tracking is allowed
 *
 * @return void
 */
export const allowTracking = () => {
  window.gdprTracking = true
}
